
const dollarfy = function(n, c, d, t){
	if(isNaN(c)) c = 2;
	c = Math.abs(c);
	if(d === undefined) d = ".";
	if(t === undefined) t = ",";
	let s = n < 0 ? "-" : "",
	i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c),10));
	let j = i.length;
	if(j > 3) j = j % 3;
	else j = 0;
	return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

export default dollarfy;


// WEBPACK FOOTER //
// ./src/Support/Dollarfy.js